import React from 'react';
import { Card } from '../../ui/Card';
import { Badge } from '../../ui/Badge';
import { Button } from '../../ui/Button';
import { CalendarIcon, MapPinIcon, ArrowRightIcon, SettingsIcon } from 'lucide-react';
import { MasterEvent, SubEvent } from './MasterEventSelector';
interface MasterEventDashboardProps {
  masterEvent: MasterEvent;
  onSelectSubEvent: (subEvent: SubEvent) => void;
}
export function MasterEventDashboard({
  masterEvent,
  onSelectSubEvent
}: MasterEventDashboardProps) {
  return <div className="space-y-8" data-id="element-1817">
      {/* Header Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-1818">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1819">
          <div data-id="element-1820">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1821">
              {masterEvent.name}
            </h1>
            <div className="flex flex-wrap gap-4 text-gray-500 text-sm" data-id="element-1822">
              <div className="flex items-center gap-2" data-id="element-1823">
                <CalendarIcon className="w-4 h-4" data-id="element-1824" />
                {masterEvent.dates}
              </div>
              <div className="flex items-center gap-2" data-id="element-1825">
                <MapPinIcon className="w-4 h-4" data-id="element-1826" />
                {masterEvent.location}
              </div>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1827">
            <Button variant="outline" onClick={() => console.log('Settings')} data-id="element-1828">
              <SettingsIcon className="w-4 h-4 mr-2" data-id="element-1829" />
              Event Settings
            </Button>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-8 border-t border-gray-100" data-id="element-1830">
          <div data-id="element-1831">
            <div className="text-sm text-gray-500 mb-1" data-id="element-1832">Total Sub-Events</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-1833">
              {masterEvent.subEvents.length}
            </div>
          </div>
          <div data-id="element-1834">
            <div className="text-sm text-gray-500 mb-1" data-id="element-1835">Total Exhibitors</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-1836">
              {masterEvent.stats.exhibitors}
            </div>
          </div>
          <div data-id="element-1837">
            <div className="text-sm text-gray-500 mb-1" data-id="element-1838">Total Sessions</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-1839">
              {masterEvent.stats.sessions}
            </div>
          </div>
          <div data-id="element-1840">
            <div className="text-sm text-gray-500 mb-1" data-id="element-1841">Expected Attendees</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-1842">
              {masterEvent.stats.attendees.toLocaleString()}
            </div>
          </div>
        </div>
      </div>

      {/* Sub-Events Section */}
      <div data-id="element-1843">
        <div className="flex items-center justify-between mb-4" data-id="element-1844">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-1845">Sub-Events</h2>
          <Button variant="outline" size="sm" data-id="element-1846">
            Add Sub-Event
          </Button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1847">
          {masterEvent.subEvents.map(subEvent => <Card key={subEvent.id} className="cursor-pointer hover:shadow-md transition-all duration-200 group" onClick={() => onSelectSubEvent(subEvent)} padding="lg" data-id="element-1848">
              <div className="flex justify-between items-start mb-4" data-id="element-1849">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center font-bold" style={{
              backgroundColor: subEvent.name === 'Dubai Muscle Show' ? '#000000' : subEvent.name === 'Dubai Active' ? '#c8e1d9' : subEvent.name === 'Dubai Active Industry' ? '#17313a' : subEvent.color,
              color: subEvent.name === 'Dubai Muscle Show' ? '#ffffff' : subEvent.name === 'Dubai Active' ? '#17313a' : subEvent.name === 'Dubai Active Industry' ? '#ffffff' : '#ffffff',
              fontSize: subEvent.name === 'Dubai Muscle Show' || subEvent.name === 'Dubai Active' || subEvent.name === 'Dubai Active Industry' ? '0.7rem' : '1.25rem'
            }} data-id="element-1850">
                  {subEvent.name === 'Dubai Muscle Show' ? 'DMS' : subEvent.name === 'Dubai Active' ? 'DA' : subEvent.name === 'Dubai Active Industry' ? 'DAI' : subEvent.name.charAt(0)}
                </div>
                <Badge variant={subEvent.type === 'B2B' ? 'default' : 'warning'} data-id="element-1851">
                  {subEvent.type}
                </Badge>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-1852">
                {subEvent.name}
              </h3>

              <div className="text-sm text-gray-500 mb-4" data-id="element-1853">{subEvent.dates}</div>

              <div className="flex items-center text-blue-600 text-sm font-medium group-hover:translate-x-1 transition-transform" data-id="element-1854">
                Manage Event <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-1855" />
              </div>
            </Card>)}
        </div>
      </div>
    </div>;
}